import { render, staticRenderFns } from "./Cocoro.vue?vue&type=template&id=e3f2060c"
import script from "./Cocoro.vue?vue&type=script&lang=js"
export * from "./Cocoro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports